import React, { Component } from 'react';
import withStyles from 'react-jss'
import {withContext} from '../main/custom/StateProvider';
import Dialog from '@material-ui/core/Dialog';
//import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
//import Button from '@material-ui/core/Button';

const styles = theme => ({
    overlay:{
        position:'absolute',
        top:0,
        left:0,
        right:0,
        bottom:0,
        backgroundColor:'rgba(0,0,0,0.6)',
        zIndex:1000,
    },
    drawer:{
        position:'absolute',
        border:'1px solid black',
        borderRadius:10,
        padding:10,
        backgroundColor: 'white',
        zIndex:1001,
        top:'50%',
        left:'50%'
    },
    closeButton:{
        float:'right',
        zIndex:1010,
    }
});

class Popup extends Component {
    state={
        wallet:[]
    };

    onClose = () => {
        this.props.context.update({
            popupContent: false,
            popupWidth:300,
            popupHeight:300
        })
    }



    render() {
        const {context} = this.props;
//content={this.props.context.drawerContent} width={this.props.context.drawerWidth} height={this.props.context.drawerHeight}
        return (

          <Dialog
            open={this.props.context.popupContent}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title"
            maxWidth={(this.props.context.popupMaxWidth) ? this.props.context.popupMaxWidth : 'auto'}
          >
              <DialogTitle id="form-dialog-title">{context.popupTitle}</DialogTitle>
              <DialogContent>
                  {context.popupContent}
              </DialogContent>
          </Dialog>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(Popup));
